import { setAsyncRoutes, resetRouter } from '../router'
import echarts from "echarts"
import axios from 'axios'
import store from '../store'

// 将菜单信息转成对应的路由信息 动态添加
export function menusToRoutes(data) {
    const result = []
    const children = []

    result.push({
        path: '/',
        component: () => import('../components/Index.vue'),
        children,
    })
    data.forEach(item => {
        generateRoutes(children, item)
    })
    children.push({
        path: 'error',
        name: 'error',
        component: () => import('../components/Error.vue')
    })
    result.push({
        path: '/home',
        redirect: "/" + children[0]["path"]
    })
    // 最后添加404页面 否则会在登陆成功后跳到404页面
    result.push(
        { path: '*', redirect: '/error' },
    )
    return result
}

function generateRoutes(children, item) {
    if (item.name) {
        children.push(setAsyncRoutes(item))
    } else if (item.children) {
        item.children.forEach(e => {
            generateRoutes(children, e)
        })
    }
}

export function resetTokenAndClearUser() {
    // 退出登陆 清除用户资料
    localStorage.setItem('token', '')
    localStorage.setItem('userImg', '')
    // 重设路由
    resetRouter()
}

export function draw_line_chart(ref, name, x_data, series) {
    // 基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(ref, "essos");
    let legend = []
    for (var i = 0; i < series.length; i++) {
        var _name = series[i]["name"]
        legend.push(_name)
        if (_name.search("百分比") != -1) {
            // 1为带%的y轴
            series[i]["yAxisIndex"] = 1
        }
        else {
            // 0为不带%的y轴
            series[i]["yAxisIndex"] = 0
        }
    }
    // 指定图表的配置项和数据
    let option = {
        title: {
            text: name
        },
        tooltip: {
            trigger: "axis",
            // formatter: function (params) {
            //     if (params[0]["seriesName"].search("百分比") != -1) {
            //         return params[0]["value"] + " %"
            //     }
            //     else {
            //         return params[0]["value"]
            //     }
            // }
        },
        legend: {
            data: legend,
            selectedMode: 'single',
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
        },
        xAxis: {
            type: "category",
            boundaryGap: false,
            data: x_data,
        },
        dataZoom: [
            {
                show: true,
                realtime: true,
                start: 0,
                end: 100,
            }
        ],
        yAxis: [
            {
                type: 'value',
                position: 'left',
                scale: true,
            },
            {
                position: 'left',
                scale: true,
                type: 'value',
                axisLabel: {
                    formatter: function (value) {
                        return value + ' %'
                    }
                },
            }
        ],
        series: series
    };
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
    myChart.on('legendselectchanged', function (obj) {
        //var selected = obj.selected;
        //var legend = obj.name;
        if (obj.name.search("USD") != -1) {
            localStorage.setItem("legend_usd_selected_name", obj.name)
        } else {
            localStorage.setItem("legend_xbt_selected_name", obj.name)
        }
    })
    // 初始化时显示的legend调整，带一定的记忆功能
    if (name.search("USD") != -1) {
        var select_name = localStorage.getItem("legend_usd_selected_name")
        if (select_name != null && legend.indexOf(select_name) != -1) {
            myChart.dispatchAction({
                type: "legendSelect",
                name: select_name,
            })
        }
    } else {
        var select_name = localStorage.getItem("legend_xbt_selected_name")
        if (select_name != null && legend.indexOf(select_name) != -1) {
            myChart.dispatchAction({
                type: "legendSelect",
                name: select_name,
            })
        }
    }
    window.addEventListener("resize", myChart.resize);
}

export function draw_pie_chart(ref, name, data) {
    // 基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(ref, "essos");
    // 指定图表的配置项和数据
    let option = {
        title: {
            text: name,
            x: "center"
        },
        tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [
            {
                name: "子策略持仓usd张数",
                type: "pie",
                radius: "55%",
                center: ["50%", "60%"],
                data: data,
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)"
                    }
                }
            }
        ]
    };
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
    window.addEventListener("resize", myChart.resize);
}

export function draw_bar_chart(ref, name, x_data, y_data, set_title_name = null) {
    // 基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(ref, "essos");
    // 指定图表的配置项和数据
    let option = {
        tooltip: {
            trigger: "axis",
            axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
        },
        xAxis: [
            {
                type: "category",
                data: x_data,//["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                axisTick: {
                    alignWithLabel: true
                }
            }
        ],
        yAxis: [
            {
                type: "value",
            }
        ],
        series: [
            {
                name: name,
                type: "bar",
                barWidth: "60%",
                data: y_data,//[10, 52, 200, 334, 390, 330, 220]
            }
        ]
    };
    if (set_title_name == null) {
        let title = {
            text: name,
            x: "center"
        };
        option["title"] = title
    }
    else {
        option["title"] = set_title_name
    }
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
    window.addEventListener("resize", myChart.resize);
}

// 数字转化成带千位分隔符风格
export function num_format(num) {
    var res = num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
            return $1 + ",";
        });
    });
    return res;
}

function roundFun(value, n) {
    return Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
}

function splitData(rawData, resample_num) {
    var categoryData = [];
    var values = [];
    var volumns = [];
    for (var i = 0; i < rawData.length; i += resample_num) {
        categoryData.push(rawData[i][0]);
        var value_temp = rawData[i].concat();
        //   0       1      2     3    4     5      6
        //datetime、open、close、low、high、volumn、count
        var start = i;
        var end = i + resample_num - 1;
        if (end >= rawData.length) {
            end = rawData.length - 1
        }
        value_temp[1] = rawData[start][1];
        value_temp[2] = rawData[end][2];
        for (var j = i + 1; j < i + resample_num; j++) {
            if (j < rawData.length) {
                value_temp[3] = value_temp[3] < rawData[j][3] ? value_temp[3] : rawData[j][3];
                value_temp[4] = value_temp[4] > rawData[j][4] ? value_temp[4] : rawData[j][4];
                for (var z = 5; z < 7; z++) {
                    value_temp[z] += rawData[j][z];
                }
            }
        }
        value_temp.splice(0, 1)
        values.push(value_temp)
        volumns.push(value_temp[4])
    }
    return {
        categoryData: categoryData,
        values: values,
        volumns: volumns,
    };
}

function judge_time_and_minute(dateTimeStr, hour, minute) {
    // 解析日期时间字符串
    var date = new Date(dateTimeStr);

    // 获取小时和分钟
    var _hour = date.getHours();
    var _minute = date.getMinutes();

    if (hour === _hour && _minute === minute) {
        return true;
    } else {
        return false;
    }
}

function add_arrow(data) {
    var result = [];
    
    for (var i = 0, len = data.values.length; i < len; i++) {
        if (judge_time_and_minute(data.categoryData[i], 9, 0) || judge_time_and_minute(data.categoryData[i], 21, 0)) {
            result.push({
                coord: [data.categoryData[i], 0],//data.values[i][2]
                itemStyle: {
                    color: 'blue'
                }
            });
            
        }
    }
    return result;
}

function calculateMA(data, dayCount) {
    var result = [];
    for (var i = 0, len = data.values.length; i < len; i++) {
        if (i < dayCount) {
            result.push('-');
            continue;
        }
        var sum = 0;
        for (var j = 0; j < dayCount; j++) {
            sum += data.values[i - j][1];
        }
        result.push(sum / dayCount);
    }
    return result;
}

function calculateBOLL(data, dayCount, boll_width, boll_percent, boll_percent_days) {
    var result = {
        "mid": [],
        "top": [],
        "bottom": [],
    };
    var if_boll_beyond_percent = []
    //求和函数
    var sum = function (x, y) { return x + y; }
    //数组中每个元素求它的平方　
    var square = function (x) { return x * x; }
    for (var i = 0, len = data.values.length; i < len; i++) {
        if (i < dayCount) {
            result["mid"].push('-');
            result["top"].push('-');
            result["bottom"].push('-');
            if_boll_beyond_percent.push('-')
            continue;
        }

        var temp = [];
        for (var j = 0; j < dayCount; j++) {
            temp.push(data.values[i - j][1]);
        }
        var mid = temp.reduce(sum) / temp.length;
        var deviations = temp.map(function (x) { return x - mid; });
        var stddev = Math.sqrt(deviations.map(square).reduce(sum) / (temp.length - 1));
        var top = mid + boll_width * stddev;
        var bottom = mid - boll_width * stddev;

        // 向上最大值，实际价格突破该值，表示当前运行在朝上轨道
        var top_limit = mid + boll_percent * (top - mid)
        var bottom_limit = mid - boll_percent * (mid - bottom)
        if_boll_beyond_percent.push(
            (bottom_limit < data.values[i][1] && data.values[i][1] < top_limit) ? false : true
        );

        result["mid"].push(mid);
        result["top"].push(top);
        result["bottom"].push(bottom);
    }
    result["if_boll_beyond_percent"] = []
    // 遍历一次，为boll_betwwen_percent赋值
    for (var i = 0, len = data.values.length; i < len; i++) {
        if (i < boll_percent_days + dayCount + 1) {
            result["if_boll_beyond_percent"].push('-');
        }
        var temp = 0;
        for (var j = 0; j < boll_percent_days; j++) {
            if (if_boll_beyond_percent[i - j] == true) {
                temp = temp + 1
            }
        }
        result["if_boll_beyond_percent"].push(100 * temp / boll_percent_days)
    }
    return result;
}

function sum(arr) {
    return arr.reduce(function (prev, curr, idx, arr) {
        return prev + curr;
    });
}

function calculateAMA(data, day_count, back_length = 25, er_eff = 0.45) {
    // AMA的公式使得其指标的计算与初始值、回测起点强相关
    // 为了剔除这个影响，尝试新的公式：保留关键的ER比率, 每一次MA均线
    // 发生变化时(MAi - Mai-1), 对这变化乘以ER比率系数，形成新的MA值
    var result = [];
    var er_value_list = [];
    for (var i = 0, len = data.values.length; i < len; i++) {
        var wave = 0;
        if (i < day_count + 1) {
            result.push('-');
            continue;
        }
        for (var j = 0; j < back_length; j++) {
            wave += Math.abs(data.values[i - j][1] - data.values[i - j - 1][1])
        }
        var Er = Math.abs(data.values[i][1] - data.values[i - back_length - 1][1]) / wave;

        er_value_list.push(Er)
        if (er_value_list.length >= back_length) {
            Er = sum(er_value_list) / back_length
            er_value_list.shift()
        }
        else {
            Er = 0
        }
        var ma_length = Math.ceil(day_count * (1 - er_eff * Er));
        var sum_ma = 0;
        for (var k = 0; k < ma_length; k++) {
            // [1] 取的是close收盘价
            sum_ma += data.values[i - k][1];
        }
        result.push(sum_ma / ma_length);
    }
    return result;
}

// 将volumns值替换成bitmex风格，K M等
function changeVolumns(volumn) {
    if (volumn < 1000) {
        return volumn.toFixed(3)
    }
    else if (volumn < 1000000) {
        return (volumn / 1000).toFixed(2) + "K"
    }
    else {
        return (volumn / 1000000).toFixed(2) + "M"
    }
}

export function draw_kline_chart(ref, text, _data, minute_num, ma_0, ma_1, if_first = false) {
    var upColor = '#00da3c';
    var upBorderColor = '#008F28';
    var downColor = '#ec0000';
    var downBorderColor = '#8A0000';
    var data = splitData(_data, minute_num)
    // 基于准备好的dom，初始化echarts实例
    var myChart = echarts.init(ref, "essos");
    var option = "";
    if (if_first == true) {
        myChart.showLoading({
            text: "正在加载数据"
        });
        option = {
            title: {
                text: text,
                left: 0
            },
            axisPointer: {
                link: { xAxisIndex: 'all' },
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross'
                },
                position: [0, 20],
                backgroundColor: 'rgba(255,255,255,0)',//通过设置rgba调节背景颜色与透明度
                color: 'black',
                borderWidth: '0',
                borderColor: 'gray',
                textStyle: {
                    color: 'black',
                },
                showDelay: 0, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
                //open、close、low、high
                formatter: function (params) {
                    if (params[0]["axisIndex"] != 0) {
                        return ""
                    }
                    else {
                        var style = 'style="font-size:12px;'
                        var color_1 = "color:#2d8cf0;";
                        var color_2 = "color:#d95850;";
                        var color_3 = "color:#73a373;";
                        var res = "<span " + style + color_1 + '" >';
                        res += '开:' + params[0]["data"][1] + " ";
                        res += "高: " + params[0]["data"][4] + " ";
                        res += "低: " + params[0]["data"][3] + " ";
                        res += "收: " + params[0]["data"][2] + " ";
                        res += "</span>";
                        res += "<span " + style + color_2 + '" >';
                        res += "MA_S: " + roundFun(params[1]["data"], 2) + " ";
                        res += "MA_L: " + roundFun(params[2]["data"], 2) + " ";
                        res += "</span>";
                        res += "<span " + style + color_3 + '" >';
                        res += "Volumn: " + changeVolumns(params[0]["data"][5]) + " ";
                        res += "count: " + params[0]["data"][6] + " ";
                        res += "</span>";
                        return res
                    }
                }
            },
            grid: [{
                left: '3%',
                right: '3%',
                top: '12%',
                height: '60%',
            },
            {
                left: '3%',
                right: '3%',
                top: '72%',
                height: '13%'
            }],
            graphic: {
                id: "show_current_msg_father1",
                type: 'group',
                right: "5%",
                top: 33,
                z: -10,
                children: [
                    {
                        id: 'show_current_msg_child1',
                        type: "text",
                        left: 15,
                        cursor: "default",
                        style: {
                            text: "Count: 400",
                            font: "normal 1000 12px Helvetica Neue",
                            fill: '#73a373',
                        }
                    },
                    {
                        id: "show_current_msg_father2",
                        type: 'group',
                        right: "5%",
                        children: [
                            {
                                type: "text",
                                id: 'show_current_msg_child2',
                                left: 15,
                                cursor: "default",
                                style: {
                                    text: "Volumn: 609K",
                                    font: "normal 1000 12px Helvetica Neue",
                                    fill: '#d95850',
                                }
                            },
                            {
                                id: "show_current_msg_father3",
                                type: 'group',
                                right: "5%",
                                children: [
                                    {
                                        type: "text",
                                        id: 'show_current_msg_child3',
                                        cursor: "default",
                                        style: {
                                            text: "Price: 7035.35$",
                                            font: "normal 1000 12px Helvetica Neue",
                                            fill: '#2d8cf0',
                                        }
                                    },

                                ]
                            }
                        ]
                    }
                ]
            },
            xAxis: [{
                show: false,
                type: 'category',
                data: data.categoryData,
                gridIndex: 0,
                scale: true,
                boundaryGap: false,
                axisLine: { onZero: false },
                splitLine: { show: false },
                axisTick: {
                    show: false,
                },
                axisPointer: {
                    label: {
                        show: false
                    }
                },
                splitNumber: 20,
                min: 'dataMin',
                max: 'dataMax',
            },
            {
                type: 'category',
                data: data.categoryData,
                gridIndex: 1,
                scale: true,
                boundaryGap: false,
                axisLine: { onZero: false },
                splitLine: { show: false },
                splitNumber: 20,
                min: 'dataMin',
                max: 'dataMax',
            }],
            yAxis: [{
                scale: true,
                gridIndex: 0,
                splitArea: {
                    show: true
                }
            }, {
                scale: true,
                gridIndex: 1,
                axisLabel: { show: false },
                axisLine: { show: false },
                axisTick: { show: false },
                splitLine: { show: false },
                axisPointer: {
                    label: {
                        show: false
                    }
                },
            }],
            dataZoom: [
                {
                    type: 'inside',
                    xAxisIndex: [0, 1],
                    start: 99,
                    end: 100
                },
                {
                    show: true,
                    xAxisIndex: [0, 1],
                    type: 'slider',
                    y: '92%',
                    start: 99,
                    end: 100
                }
            ],
            series: [
                {
                    name: minute_num + "分钟线",
                    type: 'candlestick',
                    data: data.values,
                    itemStyle: {
                        normal: {
                            color: upColor,
                            color0: downColor,
                            borderColor: upBorderColor,
                            borderColor0: downBorderColor
                        }
                    },
                    zlevel: 0,
                },
                {
                    name: 'MA' + ma_0,
                    type: 'line',
                    data: calculateMA(data, ma_0),
                    smooth: true,
                    lineStyle: {
                        width: 1//设置线条粗细
                    },
                    symbol: "none",
                    zlevel: 1,
                },
                {
                    name: 'MA' + ma_1,
                    type: 'line',
                    data: calculateMA(data, ma_1),
                    smooth: true,
                    lineStyle: {
                        width: 1//设置线条粗细
                    },
                    symbol: "none",
                    zlevel: 2,
                },
                {
                    name: 'Volumns',
                    type: 'bar',
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    data: data.volumns,
                    zlevel: 0,
                }
            ]
        };
        window.addEventListener("resize", myChart.resize);
    } else {
        var length = data.values.length;
        option = {
            title: {
                text: text,
            },
            xAxis: [
                {
                    data: data.categoryData,
                },
                {
                    data: data.categoryData,
                }
            ],
            series: [
                {
                    name: minute_num + "分钟线",
                    type: 'candlestick',
                    data: data.values,
                },
                {
                    name: 'MA' + ma_0,
                    type: 'line',
                    data: calculateMA(data, ma_0),
                },
                {
                    name: 'MA' + ma_1,
                    type: 'line',
                    data: calculateMA(data, ma_1),
                },
                {
                    name: 'Volumns',
                    type: 'bar',
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    data: data.volumns,
                    itemStyle: {
                        color: (params) => {
                            if (data.values[params["dataIndex"]][0] < data.values[params["dataIndex"]][1]) {
                                return upColor
                            }
                            else {
                                return downColor
                            }
                        }
                    }
                }
            ],
            graphic: {
                id: "show_current_msg_father1",
                type: 'group',
                $action: 'merge',
                children: [
                    {
                        id: 'show_current_msg_child1',
                        type: 'text',
                        $action: 'merge',
                        style: {
                            text: "Count: " + data.values[length - 1][5]
                        }
                    },
                    {
                        id: "show_current_msg_father2",
                        $action: 'merge',
                        type: 'group',
                        children: [
                            {
                                type: "text",
                                id: 'show_current_msg_child2',
                                $action: 'merge',
                                style: {
                                    text: "Volumn: " + changeVolumns(data.values[length - 1][4]),
                                }
                            },
                            {
                                id: "show_current_msg_father3",
                                type: 'group',
                                $action: 'merge',
                                children: [
                                    {
                                        $action: 'merge',
                                        type: 'text',
                                        id: 'show_current_msg_child3',
                                        style: {
                                            text: "Price: " + data.values[length - 1][1] + "$"
                                        }
                                    },

                                ]
                            }
                        ]
                    }
                ]
            }
        }
        myChart.hideLoading();
    }
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option, false);
}

export function history_chart_set_loading(ref, text = null) {
    var myChart = echarts.init(ref, "essos")
    if (text == null) {
        myChart.hideLoading();
    }
    else {
        myChart.showLoading({
            text: text
        });
    }
}

export function draw_history_kline_chart(ref, ref_drawer_button, text, _data,
    minute_num, ma_0, ma_1, if_first = false, myChart_father = null) {
    var upColor = '#00da3c';
    var upBorderColor = '#008F28';
    var downColor = '#ec0000';
    var downBorderColor = '#8A0000';
    var data = splitData(_data, minute_num)
    // 基于准备好的dom，初始化echarts实例
    if (myChart_father == null) {
        var myChart = echarts.init(ref, "essos");
    }
    else {
        var myChart = myChart_father
    }
    var option = "";
    if (if_first == true) {
        option = {
            title: {
                text: text,
                left: 0
            },
            axisPointer: {
                link: { xAxisIndex: 'all' },
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross'
                },
                position: [0, 20],
                backgroundColor: 'rgba(255,255,255,0)',//通过设置rgba调节背景颜色与透明度
                color: 'black',
                borderWidth: '0',
                borderColor: 'gray',
                textStyle: {
                    color: 'black',
                },
                showDelay: 0, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
                //open、close、low、high
                formatter: function (params) {
                    if (params[0]["axisIndex"] != 0) {
                        return ""
                    }
                    else {
                        var style = 'style="font-size:12px;'
                        var color_1 = "color:#2d8cf0;";
                        var color_2 = "color:#d95850;";
                        var color_3 = "color:#73a373;";
                        var res = "<span " + style + color_1 + '" >';
                        res += '开:' + params[0]["data"][1] + " ";
                        res += "高: " + params[0]["data"][4] + " ";
                        res += "低: " + params[0]["data"][3] + " ";
                        res += "收: " + params[0]["data"][2] + " ";
                        res += "幅: " + (100*(params[0]["data"][2]/params[0]["data"][1]-1)).toFixed(2) + "% ";
                        res += "</span>";
                        res += "<span " + style + color_2 + '" >';
                        res += "MA_S: " + roundFun(params[1]["data"], 2) + " ";
                        res += "MA_L: " + roundFun(params[2]["data"], 2) + " ";
                        res += "</span>";
                        res += "<span " + style + color_3 + '" >';
                        res += "Volumn: " + changeVolumns(params[0]["data"][5]) + " ";
                        res += "count: " + params[0]["data"][6] + " ";
                        res += "</span>";
                        return res
                    }
                }
            },
            grid: [{
                left: '4%',
                right: '4%',
                top: '8%',
                height: '70%',
            },
            {
                left: '4%',
                right: '4%',
                top: '78%',
                height: '13%'
            }],
            xAxis: [{
                show: false,
                type: 'category',
                data: data.categoryData,
                gridIndex: 0,
                scale: true,
                boundaryGap: false,
                axisLine: { onZero: false },
                splitLine: { show: false },
                axisTick: {
                    show: false,
                },
                axisPointer: {
                    label: {
                        show: false
                    }
                },
                min: 'dataMin',
                max: 'dataMax',
            },
            {
                type: 'category',
                data: data.categoryData,
                gridIndex: 1,
                scale: true,
                boundaryGap: false,
                axisLine: { onZero: false },
                splitLine: { show: false },
                min: 'dataMin',
                max: 'dataMax',
            }],
            yAxis: [{
                scale: true,
                gridIndex: 0,
                splitArea: {
                    show: true
                }
            }, {
                scale: true,
                gridIndex: 1,
                axisLabel: { show: false },
                axisLine: { show: false },
                axisTick: { show: false },
                splitLine: { show: false },
                axisPointer: {
                    label: {
                        show: false
                    }
                },
            }],
            dataZoom: [
                {
                    type: 'inside',
                    xAxisIndex: [0, 1],
                    start: 99,
                    end: 100
                },
                {
                    show: true,
                    xAxisIndex: [0, 1],
                    type: 'slider',
                    //y: '92%',
                    start: 99,
                    end: 100
                }
            ],
            series: [
                {
                    name: minute_num + "分钟线",
                    type: 'candlestick',
                    data: data.values,
                    itemStyle: {
                        normal: {
                            color: upColor,
                            color0: downColor,
                            borderColor: upBorderColor,
                            borderColor0: downBorderColor
                        }
                    },
                    zlevel: 0,
                },
                {
                    name: 'MA' + ma_0,
                    type: 'line',
                    data: calculateMA(data, ma_0),
                    smooth: true,
                    lineStyle: {
                        width: 1//设置线条粗细
                    },
                    symbol: "none",
                    zlevel: 1,
                },
                {
                    name: 'MA' + ma_1,
                    type: 'line',
                    data: calculateMA(data, ma_1),
                    smooth: true,
                    lineStyle: {
                        width: 1//设置线条粗细
                    },
                    symbol: "none",
                    zlevel: 2,
                },
                {
                    name: 'Volumns',
                    type: 'bar',
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    data: data.volumns,
                    zlevel: 0,
                    itemStyle: {
                        color: (params) => {
                            if (data.values[params["dataIndex"]][0] < data.values[params["dataIndex"]][1]) {
                                return upColor
                            }
                            else {
                                return downColor
                            }
                        }
                    },
                    markPoint: {
                        symbol: 'arrow',
                        symbolSize: 10,
                        symbolRotate: -90, // 旋转-90度，使箭头向上
                        data: add_arrow(data)
                    }
                }
            ],
            toolbox: {
                itemSize: 25,
                right: "3%",
                feature: {
                    myTool1: {
                        show: true,
                        title: '设置',
                        icon: "image://" + require("../assets/imgs/setting.svg"),
                        onclick: function () {
                            ref_drawer_button.$el.click();
                        }
                    },
                }
            }
        };
        window.addEventListener("resize", myChart.resize);
    } else {
        option = {
            title: {
                text: text,
            },
            xAxis: [
                {
                    data: data.categoryData,
                },
                {
                    data: data.categoryData,
                }
            ],
            series: [
                {
                    name: minute_num + "分钟线",
                    type: 'candlestick',
                    data: data.values,
                },
                {
                    name: 'MA' + ma_0,
                    type: 'line',
                    data: calculateMA(data, ma_0),
                },
                {
                    name: 'MA' + ma_1,
                    type: 'line',
                    data: calculateMA(data, ma_1),
                },
                {
                    name: 'Volumns',
                    type: 'bar',
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    data: data.volumns,
                    itemStyle: {
                        color: (params) => {
                            if (data.values[params["dataIndex"]][0] < data.values[params["dataIndex"]][1]) {
                                return upColor
                            }
                            else {
                                return downColor
                            }
                        }
                    },
                    markPoint: {
                        symbol: 'arrow',
                        symbolSize: 10,
                        symbolRotate: -90, // 旋转-90度，使箭头向上
                        data: add_arrow(data)
                    }
                }
            ],

        }
    }
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option, if_first);
}

export function draw_history_boll_chart(ref, ref_drawer_button, text, _data,
    minute_num, boll_length = 20, boll_width = 2, boll_percent = 0.1, boll_percent_days = 10, 
    if_first = false, myChart_father = null) {
    var upColor = '#00da3c';
    var upBorderColor = '#008F28';
    var downColor = '#ec0000';
    var downBorderColor = '#8A0000';
    var data = splitData(_data, minute_num);
    var boll_data = calculateBOLL(data, boll_length, boll_width, boll_percent, boll_percent_days);
    // 基于准备好的dom，初始化echarts实例
    if (myChart_father == null) {
        var myChart = echarts.init(ref, "essos");
    }
    else {
        var myChart = myChart_father
    }
    var option = "";
    if (if_first == true) {
        option = {
            title: {
                text: text,
                left: 0
            },
            axisPointer: {
                link: { xAxisIndex: 'all' },
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross'
                },
                position: [0, 20],
                backgroundColor: 'rgba(255,255,255,0)',//通过设置rgba调节背景颜色与透明度
                color: 'black',
                borderWidth: '0',
                borderColor: 'gray',
                textStyle: {
                    color: 'black',
                },
                showDelay: 0, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
                //open、close、low、high
                formatter: function (params) {
                    if (params[0]["axisIndex"] != 0) {
                        return ""
                    }
                    else {
                        var style = 'style="font-size:12px;'
                        var color_1 = "color:#2d8cf0;";
                        var color_2 = "color:#d95850;";
                        var color_3 = "color:#73a373;";
                        var res = "<span " + style + color_1 + '" >';
                        res += '开:' + params[0]["data"][1] + " ";
                        res += "高: " + params[0]["data"][4] + " ";
                        res += "低: " + params[0]["data"][3] + " ";
                        res += "收: " + params[0]["data"][2] + " ";
                        res += "</span>";
                        res += "<span " + style + color_2 + '" >';
                        res += "Top: " + roundFun(params[1]["data"], 2) + " ";
                        res += "Mid: " + roundFun(params[2]["data"], 2) + " ";
                        res += "Bottom: " + roundFun(params[3]["data"], 2) + " ";
                        res += "</span>";
                        res += "<span " + style + color_3 + '" >';
                        res += "Percent: " + roundFun(params[4]["data"], 2) + "% ";
                        res += "</span>";
                        return res
                    }
                }
            },
            grid: [{
                left: '4%',
                right: '4%',
                top: '8%',
                height: '60%',
            },
            {
                left: '4%',
                right: '4%',
                top: '68%',
                height: '13%'
            }],
            xAxis: [{
                show: false,
                type: 'category',
                data: data.categoryData,
                gridIndex: 0,
                scale: true,
                boundaryGap: false,
                axisLine: { onZero: false },
                splitLine: { show: false },
                axisTick: {
                    show: false,
                },
                axisPointer: {
                    label: {
                        show: false
                    }
                },
                min: 'dataMin',
                max: 'dataMax',
            },
            {
                type: 'category',
                data: data.categoryData,
                gridIndex: 1,
                scale: true,
                boundaryGap: false,
                axisLine: { onZero: false },
                splitLine: { show: false },
                min: 'dataMin',
                max: 'dataMax',
            }],
            yAxis: [{
                scale: true,
                gridIndex: 0,
                splitArea: {
                    show: true
                }
            }, {
                scale: true,
                gridIndex: 1,
                axisLabel: { show: false },
                axisLine: { show: false },
                axisTick: { show: false },
                splitLine: { show: false },
                axisPointer: {
                    label: {
                        show: false
                    }
                },
            }],
            dataZoom: [
                {
                    type: 'inside',
                    xAxisIndex: [0, 1],
                    start: 99,
                    end: 100
                },
                {
                    show: true,
                    xAxisIndex: [0, 1],
                    type: 'slider',
                    y: '92%',
                    start: 99,
                    end: 100
                }
            ],
            series: [
                {
                    name: minute_num + "分钟线",
                    type: 'candlestick',
                    data: data.values,
                    itemStyle: {
                        normal: {
                            color: upColor,
                            color0: downColor,
                            borderColor: upBorderColor,
                            borderColor0: downBorderColor
                        }
                    },
                    zlevel: 0,
                },
                {
                    name: 'Boll_Top',
                    type: 'line',
                    data: boll_data["top"],
                    smooth: true,
                    lineStyle: {
                        width: 2//设置线条粗细
                    },
                    symbol: "none",
                    zlevel: 1,
                },
                {
                    name: 'Boll_Mid',
                    type: 'line',
                    data: boll_data["mid"],
                    smooth: true,
                    lineStyle: {
                        width: 1//设置线条粗细
                    },
                    symbol: "none",
                    zlevel: 2,
                },
                {
                    name: 'Boll_Bottom',
                    type: 'line',
                    data: boll_data["bottom"],
                    smooth: true,
                    lineStyle: {
                        width: 2//设置线条粗细
                    },
                    symbol: "none",
                    zlevel: 3,
                },
                {
                    name: 'Volumns',
                    type: 'bar',
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    data: boll_data["if_boll_beyond_percent"],
                    zlevel: 0,
                    itemStyle: {
                        color: (params) => {
                            if (boll_data["if_boll_beyond_percent"][params["dataIndex"]] < 70) {
                                return upColor
                            }
                            else {
                                return downColor
                            }
                        }
                    }
                }
            ],
            toolbox: {
                itemSize: 25,
                right: "3%",
                feature: {
                    myTool1: {
                        show: true,
                        title: '设置',
                        icon: "image://" + require("../assets/imgs/setting.svg"),
                        onclick: function () {
                            ref_drawer_button.$el.click();
                        }
                    },
                }
            }
        };
        window.addEventListener("resize", myChart.resize);
    } else {
        option = {
            title: {
                text: text,
            },
            xAxis: [
                {
                    data: data.categoryData,
                },
                {
                    data: data.categoryData,
                }
            ],
            series: [
                {
                    name: minute_num + "分钟线",
                    type: 'candlestick',
                    data: data.values,
                },
                {
                    name: 'Boll_Top',
                    type: 'line',
                    data: boll_data["top"],
                },
                {
                    name: 'Boll_Mid',
                    type: 'line',
                    data: boll_data["mid"],
                },
                {
                    name: 'Boll_Bottom',
                    type: 'line',
                    data: boll_data["bottom"],
                },
                {
                    name: 'Volumns',
                    type: 'bar',
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    data: boll_data["if_boll_beyond_percent"],
                    itemStyle: {
                        color: (params) => {
                            if (boll_data["if_boll_beyond_percent"][params["dataIndex"]] < 70) {
                                return upColor
                            }
                            else {
                                return downColor
                            }
                        }
                    }
                }
            ],

        }
    }
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option, false);
    //return myChart
}

export function array_to_object(hearder_name_array, data) {
    let res = []
    for (var i = 0; i < data.length; i++) {
        var temp = {}
        for (var j = 0; j < data[i].length; j++) {
            temp[hearder_name_array[j]] = data[i][j]
        }
        res.push(temp)
    }
    return res
}

export function triggerResize(trigger_delay = 50) {
    // 触发一次resize事件，可用来重绘echarts
    var myEvent = new Event('resize');
    setTimeout(function () {
        window.dispatchEvent(myEvent);
    }, trigger_delay); //需要一个延迟，resize()才能生效
}

export async function test(log) {
    // 触发一次axios，发送一个log信息，用以静默模式下运行的浏览器输出log日志
    const formData = new FormData();
    formData.append("data", log);
    formData.append("account_id", 1);
    formData.append("mode", "log");
    await axios({
        url: store.state.urlPort + "/strategy_report",
        method: "post",
        data: formData
    })
}